import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from './AnimatedSection';

const FinalCTA: React.FC = () => {
  return (
    <section className="relative border-t border-surface-border bg-surface">
      <div className="section-pad">
        <div className="max-w-3xl mx-auto text-center">
          <AnimatedSection animation="slide-up">
            <h2 className="section-title mb-6 text-balance">
              Ready to Modernize Your Business?
            </h2>
            <p className="section-body mx-auto mb-10">
              Let&apos;s build the intelligent systems your business needs to grow.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/contact" className="btn-primary text-base px-8 py-3.5 w-full sm:w-auto">
                Book a Strategy Session
              </Link>
              <a href="#work" className="btn-secondary text-base px-8 py-3.5 w-full sm:w-auto">
                View Our Work
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
